export default "__VITE_ASSET__BIiZ_fVh__"